import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import BatchContext from '../../BatchContext';
import Property from '../../../../Property';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import camelize from '@afosto/utils/string/camelize';
import useIntl from '@afosto/utils-react/intl/useIntl';
import getSchemas from '../../../../BatchForm/BatchActionForm/getSchemas';
import { datetime } from '../../../../DataGrid/formatters';
import formatCurrency from '@afosto/utils/formatCurrency';
import PriceGroupFormatter from '@afosto/utils-react/formatters/PriceGroupFormatter';
import CountryFormatter from '@afosto/utils-react/formatters/CountryFormatter';
import WmsLocationFormatter from '@afosto/utils-react/formatters/WmsLocationFormatter';
import FulfilmentLocationFormatter from '@afosto/utils-react/formatters/FulfilmentLocationFormatter';
import translations from './translations';
import arrayFromNumber from '@afosto/utils/array/arrayFromNumber';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const BatchConfig = ({ isLoading }) => {
  const intl = useIntl();
  const { batch } = useContext(BatchContext);
  const { config = {}, action_id: actionID } = batch ?? {};
  const schema = getSchemas(intl, actionID);

  const formatValue = (key, value) => {
    const format = schema?.format?.[key];

    switch (format) {
      case 'dateTime':
        return datetime(value);
      case 'currency':
        return formatCurrency(value);
      case 'priceGroup':
        return <PriceGroupFormatter pricingGroupID={value} />;
      case 'country':
        return <CountryFormatter countryIso={value} />;
      case 'wmsLocation':
        return <WmsLocationFormatter wmsLocationID={value} />;
      case 'fulfilmentLocation':
        return <FulfilmentLocationFormatter fulfilmentLocationID={value} />;
      default:
        return value;
    }
  };

  if (isLoading) {
    return (
      <Card>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
        />
        <CardContent>
          {arrayFromNumber(5).map(key => (
            <Property
              key={key}
              label={<SkeletonBody lines={1} style={{ width: '10rem', marginBottom: '.75rem' }} />}
              value={<SkeletonBody lines={1} style={{ width: '5rem', marginBottom: '2rem' }} />}
            />
          ))}
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        {Object.keys(config).map(key => (
          <Property
            label={intl.formatMessage({
              id: `batchActionForm.actions.${camelize(actionID)}.columns.${camelize(key)}`,
              defaultMessage: key,
              description: `Label of te ${key} property`,
            })}
            value={formatValue(key, config[key] !== '' ? config[key] : null)}
          />
        ))}
      </CardContent>
    </Card>
  );
};

BatchConfig.propTypes = {
  isLoading: PropTypes.bool,
};

BatchConfig.defaultProps = {
  isLoading: false,
};

export default BatchConfig;
